import React, {useState} from 'react';
import '../App.css';
import { baseUrl } from '../components/BaseUrl';
import logo from '../assets/img/codeflare-app.webp';
import { Link } from 'react-router-dom';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from 'axios';
const date = new Date();

const Register = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [passwordVisibile, setPasswordVisible] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({
    score: 0,
    feedback: [],
    isValid: false
  });

  // Password requirements configuration
  const passwordRequirements = [
    { id: 'length', text: 'At least 8 characters', test: (pwd) => pwd.length >= 8 },
    { id: 'uppercase', text: 'One uppercase letter (A-Z)', test: (pwd) => /[A-Z]/.test(pwd) },
    { id: 'lowercase', text: 'One lowercase letter (a-z)', test: (pwd) => /[a-z]/.test(pwd) },
    { id: 'number', text: 'One number (0-9)', test: (pwd) => /[0-9]/.test(pwd) },
    { id: 'special', text: 'One special character (!@#$% etc.)', test: (pwd) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd) }
  ];

  // Password strength checker
  const checkPasswordStrength = (password) => {
    let score = 0;
    const feedback = [];

    passwordRequirements.forEach(req => {
      if (req.test(password)) {
        score += 1;
      } else {
        feedback.push(req.text);
      }
    });

    const isValid = score >= 4 && password.length >= 8;

    setPasswordStrength({
      score,
      feedback,
      isValid
    });
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    checkPasswordStrength(newPassword);
  };

  const showPassword = () => {
    setPasswordVisible(!passwordVisibile);
  }

  const validate = () => {
    if(firstName === ""){
      Swal.fire({
        title: "Empty Submission",
        text: "Please enter your first name",
        icon: "error",
        confirmButtonText: "OK",
        backdrop: `
        rgba(143, 70, 0, 0.3)
        url("")
        left top
        no-repeat
      `
      });
    }else if(lastName === ""){
      Swal.fire({
        title: "Empty Submission",
        text: "Please enter your last name",
        icon: "error",
        confirmButtonText: "OK",
        backdrop: `
        rgba(143, 70, 0, 0.3)
        url("")
        left top
        no-repeat
      `
      });
    }else if(email === ""){
      Swal.fire({
        title: "Empty Submission",
        text: "Please enter your email",
        icon: "error",
        confirmButtonText: "OK",
        backdrop: `
        rgba(143, 70, 0, 0.3)
        url("")
        left top
        no-repeat
      `
      });
    }
    else if(password === ""){
      Swal.fire({
        title: "Empty Submission",
        text: "Please enter your password",
        icon: "error",
        confirmButtonText: "OK",
        backdrop: `
        rgba(143, 70, 0, 0.3)
        url("")
        left top
        no-repeat
      `
      });
    }
    else if(!passwordStrength.isValid){
      Swal.fire({
        title: "Weak Password ",
        html: `
        <br />
          <div style="text-align: left;">
            <p>Your password doesn't meet the security requirements:</p>
            <ul style="margin-left: 20px;">
              ${passwordStrength.feedback.map(item => `<li>${item}</li>`).join('')}
            </ul>
          </div>
        `,
        icon: "warning",
        confirmButtonText: "OK",
        backdrop: `
        rgba(143, 70, 0, 0.3)
        url("")
        left top
        no-repeat
      `
      });
    }else{
      doRegister();
    }
  }

  const doRegister = () => {
    setLoading(true);
    setDisabled(true);
    const userData = {
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      email: email.trim(),
      // phone: phone,
      password: password,
      type: 'email'
    };
    axios.post(`${baseUrl}create-user.php`, userData).then((response) => {
      console.log(response.data)
      if(response.data.message === "Email already exists."){
        Swal.fire({
          title: "Duplicate Email",
          text: "Email already exists.",
          icon: "error",
          confirmButtonText: "OK",
          backdrop: `
          rgba(143, 70, 0, 0.3)
          url("")
          left top
          no-repeat
        `
        });
        setLoading(false);
        setDisabled(false);
      }else if(response.data.message === "Phone number already exists."){
        Swal.fire({
          title: "Duplicate Phone Number",
          text: "Phone number already exists",
          icon: "error",
          confirmButtonText: "OK",
          backdrop: `
          rgba(143, 70, 0, 0.3)
          url("")
          left top
          no-repeat
        `
        });
        setLoading(false);
        setDisabled(false);
      }else if(response.data.status === 1 || response.data.status == "Returning Email User"){
        setLoading(false);
        setDisabled(false);
        let timerInterval
        Swal.fire({
        title: response.data.message,
        icon: "success",
        html: 'Redirecting in <b></b> milliseconds.',
        timer: 1000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading()
          const b = Swal.getHtmlContainer().querySelector('b')
          timerInterval = setInterval(() => {
            b.textContent = Swal.getTimerLeft()
          }, 100)
        },
        willClose: () => {
          clearInterval(timerInterval)
        }
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.timer) {
          window.location.replace("/login")
        }
      })
    }else{
      Swal.fire({
        title: "Error",
        text: response.data.message,
        icon: "error",
        confirmButtonText: "OK",
        backdrop: `
        rgba(143, 70, 0, 0.3)
        url("")
        left top
        no-repeat
      `
      });
      setLoading(false);
      setDisabled(false);
    }
    });
  };

  // Get strength color and text
  const getStrengthInfo = () => {
    if (password.length === 0) return { color: 'transparent', text: '' };
    if (passwordStrength.score <= 2) return { color: '#ff4d4f', text: 'Weak' };
    if (passwordStrength.score === 3) return { color: '#faad14', text: 'Fair' };
    if (passwordStrength.score === 4) return { color: '#52c41a', text: 'Good' };
    return { color: '#28a745', text: 'Strong' }; // Changed to green for Strong
  };

  const strengthInfo = getStrengthInfo();

  return(
    <div className="register-container">
      <div className="login-background">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
      </div>
      
      <section className="register-section">
        <div className="register-card">
          <div className="register-header">
            <Link to="/"><img src={logo} className="logo" alt="Codeflare" /></Link>
            <Link to="/" className="close-button">
              <i className="fas fa-times"></i>
            </Link>
          </div>
          
          <div className="register-content">
            <div className="register-form">
              <h2 className='font-weight-bold'>Create Account</h2>
              <p className="register-subtitle text-center">Join us to start your learning journey</p>
              
              <form>
                <div className="input-row">
                  <div className="input-group half-width">
                    <div className="input-field">
                      <i className="fas fa-user input-icon"></i>
                      <input 
                        type="text" 
                        onChange={(e) => setFirstName(e.target.value)} 
                        required 
                        placeholder="First name"
                      />
                    </div>
                  </div>
                  
                  <div className="input-group half-width">
                    <div className="input-field">
                      <i className="fas fa-user input-icon"></i>
                      <input 
                        type="text" 
                        onChange={(e) => setLastName(e.target.value)} 
                        required 
                        placeholder="Last name"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="input-group">
                  <div className="input-field">
                    <i className="fas fa-envelope input-icon"></i>
                    <input 
                      type="email" 
                      onChange={(e) => setEmail(e.target.value)} 
                      required 
                      placeholder="Email address"
                    />
                  </div>
                </div>
                
                <div className="input-group">
                  <div className="input-field">
                    <i className="fas fa-lock input-icon"></i>
                    <input 
                      type={passwordVisibile ? "text" : "password"} 
                      required 
                      onChange={handlePasswordChange}
                      placeholder="Create password"
                    />
                    <i 
                      onClick={showPassword} 
                      className={passwordVisibile ? "fa fa-eye-slash password-toggle" : "fa fa-eye password-toggle"}
                    ></i>
                  </div>
                  
                  {/* Password Strength Indicator */}
                  
                  
                  {/* Modern Password Requirements */}
                  <div>
                    {password.length > 0 && (
                    <div className="password-strength-indicator">
                      <div className="strength-header">
                        <span className="strength-text" style={{ color: strengthInfo.color }}>
                          {`${strengthInfo.text} `}
                        </span>
                        <span className="strength-score">
                          {`${passwordStrength.score}`}/5 requirements met
                        </span>
                      </div>
                      <div className="strength-bar">
                        <div 
                          className="strength-fill"
                          style={{
                            width: `${(passwordStrength.score / 5) * 100}%`,
                            backgroundColor: strengthInfo.color
                          }}
                        ></div>
                      </div>
                    </div>
                  )}
                  <div className={`password-requirements ${password.length > 0 ? 'active' : ''}`}>
                    {/* <p className="requirements-title">Password Requirements:</p> */}
                    <div className="requirements-list">
                      {passwordRequirements.map((req) => {
                        const isMet = req.test(password);
                        return (
                          <div 
                            key={req.id} 
                            className={`requirement-item ${isMet ? 'requirement-met' : 'requirement-unmet'}`}
                          >
                            <div className="requirement-icon">
                              {isMet ? (
                                <i className="fas fa-check"></i>
                              ) : (
                                <i className="fas fa-times"></i>
                              )}
                            </div>
                            <span className="requirement-text">{req.text}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                </div>
                
                <button 
                  disabled={disabled} 
                  type="button" 
                  onClick={validate}
                  className="login-button"
                >
                  {loading ? (
                    <Spinner animation="border" variant="light" size="sm" />
                  ) : (
                    "Create Account"
                  )}
                </button>
                
                <div className="login-link">
                  <p>Already have an account? <Link to="/login">Sign In</Link></p>
                </div>
              </form>
            </div>
          </div>
          
          <div className="register-footer">
            <p>&copy; {date.getFullYear()} | Codeflare</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Register;